import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';

export const getProgramCreateState = createSelector(
	fromFeature.getProgramsState,
	(state: fromFeature.ProgramsState) => state.create
);
